import React from 'react';
import {Routes} from 'components/Routes';

const App = () => <Routes />;

export default App;
